module.exports = __webpack_public_path__ + "static/media/20220514-steirische-lm-yopchagi.4b723e69.jpg";